import { Button, ButtonIconWithLabel, Icon_OpenNew24, Spinner } from "@shapr3d/frontend-lib";

import { useDeepLinkStateStore } from "../../../stores/deepLinkStateStore";
import { TeamID } from "../../../types";
import { formatDate } from "../../../utils/helpers";
import { HeaderBreadCrumbs } from "../../ProjectPageHeader/ProjectPageHeader";
import { UserName } from "../../UserName/UserName";

import style from "./ProjectMetadata.module.css";

type ProjectMetadataProps = {
  teamId?: TeamID;
  spaceName?: string;
  projectName: string;
  lastModifiedAt?: Date;
  userName?: string;
  isCurrentUser: boolean;
  isLoading: boolean;
  showEditInAppButton: boolean;
};

export const ProjectMetadata = ({
  teamId,
  spaceName,
  projectName,
  lastModifiedAt,
  userName,
  isCurrentUser,
  isLoading,
  showEditInAppButton,
}: ProjectMetadataProps) => {
  const { setIsModalOpen: setIsDeepLinkModalOpen } = useDeepLinkStateStore();

  if (isLoading) {
    return (
      <div className={style.loadingContainer}>
        <Spinner size={20} />
      </div>
    );
  }

  return (
    <div className={style.projectData}>
      {teamId && spaceName && (
        <div className={style.breadcrumbs}>
          <HeaderBreadCrumbs teamID={teamId} spaceName={spaceName} />
        </div>
      )}
      <div className={style.title}>{projectName}</div>
      <div>
        {lastModifiedAt && (
          <div className={style.lastEdited}>Last edited: {formatDate(lastModifiedAt)}</div>
        )}
        {userName && (
          <UserName name={userName} isCurrentUser={isCurrentUser ?? false} color="gray" />
        )}
      </div>
      {showEditInAppButton && (
        <Button
          variant="grayscale"
          className={style.editInAppButton}
          onClick={() => setIsDeepLinkModalOpen(true)}
        >
          <ButtonIconWithLabel icon={<Icon_OpenNew24 />} label="Edit in Shapr3D app" />
        </Button>
      )}
    </div>
  );
};
